import actions from "./actions"

export default function configurationReducer(state = {}, action:{payload: any, type: string}):any{
    switch (action.type){
        case actions.SET_CONFIGURATION:
            return action.payload;
        case actions.SET_INITIAL_CONFIGURATION:
            return {}
        default:
            return state;
    }
}